import * as types from './actionTypes'
import sessionApi from '../api/SessionApi'
import {history} from '../index'

// Action: LOGINSUCCESS
export function loginSuccess (res) {
  return {
    type: types.LOG_IN_SUCCESS,
    res
  }
}

export function loginFailed(code, error) {
  return {
    type: types.LOG_IN_FAILED,
    code,
    message: error
  }
}

export function logOut(){
  return {type: types.LOG_OUT}
}

export function persistUser () {
  return {type: types.PERSIST_USER}
}

//Action Creator: LOGINUSER
//1. Makes authentification request to API
//2. Store the JWT in session Storage
//3. Dispatch the LoginSuccess action to the reducer
export function logInUser(credentials) {
  return function(dispatch) {
    //1.
    return sessionApi.login(credentials)
    .then(response => {
      dispatch(loginSuccess(response));
    })
    .catch(error => {
      error.json().then((json) => {
        dispatch(loginFailed(error.status, json.error))
      })
    })
  };
}

export function logOutUser(){
  return function(dispatch) {
    dispatch(logOut())
    history.push('/')
  }
}



// WEBPACK FOOTER //
// ./src/actions/sessionActions.js